import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// [F-MININAV2 T-9] Közös előnézet-építőkockák (.pjp-* osztályok — styles/_preview.scss).
// A Projektek és a Keresés eddig szó szerint másolta ezeket (Stat, UserRow, ROLE_LABEL, …).
import React, { useState } from 'react';
import { formatTimestamp } from './format';
export const ROLE_LABEL = {
    firstrecruiter: 'Projektfelelős',
    recruiter: 'Recruiter',
    sourcer: 'Sourcer',
    sales: 'Sales',
    hire: 'Hiring Manager',
    agency: 'Ügynökség',
};
export function PreviewSpinner() {
    return (_jsxs("div", { className: "pjp-spinner", children: [_jsx("i", { className: "fas fa-spinner fa-spin", "aria-hidden": "true" }), _jsx("span", { children: "Bet\u00F6lt\u00E9s\u2026" })] }));
}
/** Egy ikon + érték + címke statisztika-doboz. */
export function Stat({ icon, value, label }) {
    return (_jsxs("div", { className: "pjp-stat", children: [_jsx("i", { className: 'fas ' + icon, "aria-hidden": "true" }), _jsx("span", { className: "pjp-stat-value", children: value }), _jsx("span", { className: "pjp-stat-label", children: label })] }));
}
export function UserRow({ user }) {
    const role = user.role ? ROLE_LABEL[user.role] || user.role : '';
    return (_jsxs("div", { className: "pjp-user", children: [_jsx("i", { className: "fas fa-user-circle", "aria-hidden": "true" }), _jsx("span", { className: "pjp-user-name", children: user.name || '' }), role ? _jsx("span", { className: "pjp-user-role", children: role }) : null] }));
}
export function UsersSection({ users }) {
    const list = users || [];
    if (!list.length) {
        return null;
    }
    return (_jsxs("div", { className: "pjp-section", children: [_jsx("div", { className: "pjp-section-title", children: "Felhaszn\u00E1l\u00F3k" }), _jsx("div", { className: "pjp-users", children: list.map((u, i) => (_jsx(UserRow, { user: u }, u.id + '-' + i))) })] }));
}
/** Kulcs–érték sorok egy szekcióban (üres listánál semmi). */
export function KeyValueSection({ rows }) {
    if (!rows.length) {
        return null;
    }
    return (_jsx("div", { className: "pjp-section", children: _jsx("div", { className: "pjp-rows", children: rows.map((r) => (_jsxs("div", { className: "pjp-row", children: [_jsx("span", { className: "pjp-row-key", children: r.label }), _jsx("span", { className: "pjp-row-val", children: r.value })] }, r.key))) }) }));
}
/** Egy linkelhető kapcsolati sor (mailto/tel) vagy sima szöveg, ikonnal. */
export function ContactRow({ icon, label, value, href }) {
    return (_jsxs("div", { className: "pjp-row", children: [_jsxs("span", { className: "pjp-row-key", children: [_jsx("i", { className: 'fas ' + icon + ' pjp-row-icon', "aria-hidden": "true" }), " ", label] }), _jsx("span", { className: "pjp-row-val", children: href ? (_jsx("a", { href: href, className: "pjp-row-link", children: value })) : (value) })] }));
}
export function ChipSection({ title, items }) {
    if (!items || items.length === 0) {
        return null;
    }
    return (_jsxs("div", { className: "pjp-section", children: [_jsx("div", { className: "pjp-section-title", children: title }), _jsx("div", { className: "pjp-chips", children: items.map((c, i) => (_jsx("span", { className: "pjp-chip", children: c }, i))) })] }));
}
export function LastEventSection({ pv }) {
    const hasEvent = !!(pv.lastEventLabel || pv.lastEventDetail || pv.lastEventRelative);
    if (!hasEvent) {
        return null;
    }
    const head = [pv.lastEventRelative, pv.lastEventLabel].filter(Boolean).join(' · ');
    return (_jsxs("div", { className: "pjp-section", children: [_jsx("div", { className: "pjp-section-title", children: "Utols\u00F3 esem\u00E9ny" }), _jsxs("div", { className: "pjp-event", children: [head ? (_jsxs("div", { className: "pjp-event-head", children: [_jsx("i", { className: "fas fa-clock", "aria-hidden": "true" }), " ", head] })) : null, pv.lastEventDetail ? _jsx("div", { className: "pjp-event-detail", children: pv.lastEventDetail }) : null] })] }));
}
export function ModifiedFooter({ modifiedAt }) {
    if (!modifiedAt) {
        return null;
    }
    return _jsxs("div", { className: "pjp-footer", children: ["M\u00F3dos\u00EDtva: ", formatTimestamp(modifiedAt)] });
}
/**
 * Az előnézet fejléce: fotó (hibára ikon-fallback) vagy ikon, cím, alcím, opcionális
 * aktív/inaktív pötty (projekt / hirdetés).
 */
export function PreviewHeader(props) {
    const { photoUrl, iconClass, title, subtitle, showDot, isActive } = props;
    const [photoFailed, setPhotoFailed] = useState(false);
    const photo = (photoUrl || '').trim();
    const showPhoto = photo !== '' && !photoFailed;
    return (_jsxs("div", { className: "pjp-header", children: [showPhoto ? (_jsx("img", { className: "pjp-avatar", src: photo, alt: "", onError: () => setPhotoFailed(true) })) : (_jsx("span", { className: "pjp-header-icon", children: _jsx("i", { className: iconClass, "aria-hidden": "true" }) })), _jsxs("div", { className: "pjp-title", children: [_jsxs("div", { className: "pjp-title-line", children: [showDot ? (_jsx("i", { className: 'fas fa-circle pjp-dot ' + (isActive ? 'is-active' : 'is-inactive'), title: isActive ? 'Aktív' : 'Inaktív', "aria-hidden": "true" })) : null, _jsx("h3", { children: title })] }), subtitle ? _jsx("div", { className: "pjp-subtitle", children: subtitle }) : null] })] }));
}
